/**
 * EXISTING / NEW status pill for repeatable unit tables (#999 Devices).
 */

import React from 'react';
import { StyleSheet, Text, View } from 'react-native';

import { spacing } from '../../theme';
import { normalizeRepeatableUnitStatus } from '../../utils/groupUnitsByLocationThenStatus';

export interface RepeatableUnitStatusPillProps {
  status: 'existing' | 'new' | string | null | undefined;
  testID?: string;
}

export const RepeatableUnitStatusPill: React.FC<
  RepeatableUnitStatusPillProps
> = ({ status, testID }) => {
  const bucket = normalizeRepeatableUnitStatus(
    status == null ? undefined : String(status),
  );
  const isExisting = bucket === 'existing';
  const label = isExisting ? 'EXISTING' : 'NEW';

  return (
    <View
      testID={testID}
      style={[styles.pill, isExisting ? styles.pillExisting : styles.pillNew]}
      accessibilityRole="text"
      accessibilityLabel={label}
    >
      <Text
        style={[
          styles.pillText,
          isExisting ? styles.pillTextExisting : styles.pillTextNew,
        ]}
        numberOfLines={1}
      >
        {label}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  pill: {
    alignSelf: 'flex-start',
    maxWidth: '100%',
    borderRadius: 4,
    paddingHorizontal: spacing.xs,
    paddingVertical: 3,
  },
  pillExisting: {
    backgroundColor: 'rgba(52, 199, 89, 0.15)',
  },
  pillNew: {
    backgroundColor: 'rgba(255, 107, 53, 0.15)',
  },
  pillText: {
    fontSize: 10,
    fontWeight: '700',
    letterSpacing: 0.2,
  },
  pillTextExisting: {
    color: '#1B7A34',
  },
  pillTextNew: {
    color: '#C24A1A',
  },
});
